<template>
  <div class="root row hcenter">
    <div class="card text-white">
      <div class="card-content" ref="fields-container">
        <!-- <div class="col">
          <template v-if="errors.signup">
            <StatusInfo status="error" :message="errors.signup.message" />
          </template>
        </div> -->
        <template v-if="apiStatus === 3">
          <StatusInfo
            status="error"
            :message="signupErrors.message"
            :timeout="statusTimeout"
          />
        </template>

        <template v-if="invalidToken">
          <StatusInfo
            status="error"
            message="Your session has expired and therefore need to login again"
            :timeout="10000"
          />
        </template>

        <form @submit.prevent="signup">
          <InputField
            label="username"
            icon="account_circle"
            focusClass="text-white"
            :focus="true"
            :error="errors.username"
            @keyup="handleKeys($event, 'username')"
          />
          <InputField
            type="email"
            label="email"
            icon="email"
            focusClass="text-white"
            :error="errors.email"
            @keyup="handleKeys($event, 'email')"
          />
          <InputField
            label="Phone Number"
            icon="local_phone"
            focusClass="text-white"
            id="phone"
            :error="errors.phone"
            @keyup="handleKeys($event, 'phone')"
          />
          <InputField
            label="password"
            focusClass="text-white"
            iconClickable
            :error="errors.password"
            :type="passwordInputType"
            :icon="passwordToggleIcon"
            @iconClick="togglePasswordVisibility"
            @keyup="handleKeys($event, 'password')"
          />

          <button
            class="block mb-2 waves"
            type="submit"
            :class="apiStatus === 1 ? 'pulse' : null"
          >
            Signup
          </button>
        </form>
        <div>
          <router-link :to="{ name: 'Login' }">Login Instead</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from "vuex";

import InputField from "@/components/InputField";
import StatusInfo from "@/components/StatusInfo";

export default {
  name: "Signup",
  metaInfo() {
    return {
      title: "SignUp | Curio Travels",
    };
  },
  components: {
    InputField,
    StatusInfo,
  },
  props: {
    invalidToken: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      apiStatus: "Auth/getSignupApiStatus",
      signupErrors: "Auth/getSignupErrors",
    }),
  },
  data() {
    return {
      passwordInputType: "password",
      passwordToggleIcon: "visibility",

      errors: {
        phone: "",
        email: "",
        username: "",
        password: "",
      },

      statusTimeout: 10000,
      statusTimeoutID: null,
    };
  },
  mounted() {
    T.waves();
  },
  methods: {
    togglePasswordVisibility() {
      if (this.passwordInputType === "password") {
        this.passwordToggleIcon = "visibility_off";
        this.passwordInputType = "text";
      } else {
        this.passwordInputType = "password";
        this.passwordToggleIcon = "visibility";
      }
    },
    handleKeys(e, type) {
      if (e.key === "Tab" || e.key === "Shift") return;

      if (e.target.value.trim() !== "") this.errors[type] = "";
      else this.errors[type] = `Please enter your ${type}`;
    },

    signup(e) {
      this.$store.commit("Auth/setSignupApiStatus", 0);
      if (this.statusTimeoutID !== null) {
        clearTimeout(this.statusTimeoutID);
        this.statusTimeoutID = null
      }

      const form = e.target;
      const formData = new FormData(form);

      const phone = formData.get("phone");
      const email = formData.get("email");
      const username = formData.get("username");
      const password = formData.get("password");

      if (phone && email && username && password) {
        const payload = {
          email,
          username,
          password,
          phoneNumber: phone,
        };

        this.$store
          .dispatch("Auth/signup", payload)
          .then(() => {
            if (this.apiStatus === 2) {
              this.$router.push({
                name: "Login",
                params: { username },
                props: true,
              });
              return;
            }

            const errors = this.signupErrors.data;
            for (const field in errors) {
              const errValues = errors[field];
              let err = "";
              if (typeof errValues === "string") {
                err = errValues;
              } else {
                err = errValues[0];
              }

              this.errors[field] = err;
              console.log("Error: ", err);
            }

            this.statusTimeoutID = setTimeout(() => {
              this.$store.commit("Auth/setSignupApiStatus", 0);
              this.statusTimeoutID = null
            }, this.statusTimeout + 1000);
            window.se = this.signupErrors;
            window.e = this.errors;
          })
          .catch(() => {});
      }

      if (!phone) this.errors.phone = "Please enter your phone";
      else this.errors.phone = "";
      if (!username) this.errors.username = "Please enter your username";
      else this.errors.username = "";
      if (!email) this.errors.email = "Please enter your email";
      else this.errors.email = "";
      if (!password) this.errors.password = "Please enter your password";
      else this.errors.password = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.root .card {
  width: 100%;
  color: white;
  max-width: 330px;
  background-color: #000000da;

  @supports ((backdrop-filter: blur(20px))) {
    backdrop-filter: blur(20px);
    background-color: #000000a9;
    border: 2px solid #ffffff29;
  }
}

.txt {
  input[type="text"],
  input[type="password"] {
    background-color: #f57c0049;
    color: inherit;

    &:-webkit-autofill {
      -webkit-text-fill-color: white;
      box-shadow: 0 0 0px 1000px #000000ad inset;
    }
  }

  i {
    color: white;
  }
}
</style>
